<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  async created(){
    if(localStorage.token){
      await this.$store.dispatch('FILL_TOKEN',localStorage.token);
    }
    else{
      this.$router.push('/login');
    }
  },
  methods: {
    initializeLayout() {
      this.$rtl.disableRTL();
     /* if (!this.$rtl.isRTL) {
        // Just make sure rtl css is off when we are not on rtl

      }*/
    }
  },
  mounted() {
    this.initializeLayout();
  }
};
</script>
<style>
  body{
    direction: ltr !important;
  }
</style>
